<h5 mat-dialog-title i18n>{{ data.title }}</h5>
<div mat-dialog-content>
  <form #dialogForm="ngForm">
    <p i18n>{{ data.message }}</p>
    <div class="form-group float-right">
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" (click)="confirm()" i18n>OK</button>
      <button type="button" mat-button (click)="close(null)" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>
